export function Spinner({ size = 'md' }: { size?: 'sm' | 'md' | 'lg' }) {
  const dim = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-8 w-8' : 'h-6 w-6';
  return (
    <span
      role="status"
      aria-label="loading"
      className={`${dim} inline-block animate-spin rounded-full border-2 border-slate-300 border-t-slate-700`}
    />
  );
}

export function PageLoader({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center gap-3 text-slate-500">
      <Spinner size="lg" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
